import { message } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { buildRmReferralLink } from '../api/baseUrls';

export function getLoggedInUserUuid(user) {
  return String(user?.uuid ?? user?.id ?? '').trim();
}

export function useRmReferralLink() {
  const { user } = useAuth();
  const userUuid = getLoggedInUserUuid(user);
  const referralLink = userUuid ? buildRmReferralLink(userUuid) : '';

  const copyReferralLink = async () => {
    if (!referralLink) {
      message.error('Unable to build referral link — user UUID is missing.');
      return false;
    }
    try {
      await navigator.clipboard.writeText(referralLink);
      message.success('Link copied');
      return true;
    } catch {
      message.error('Could not copy link to clipboard.');
      return false;
    }
  };

  return { userUuid, referralLink, copyReferralLink, hasReferralLink: Boolean(referralLink) };
}

export default useRmReferralLink;
